import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideMarkdown } from 'ngx-markdown';
import { provideUnleashProxy } from '@karelics/angular-unleash-proxy-client';


import { routes } from './app.routes';
import { AuthService } from './auth/services/auth.service';
import { LocationDataParser } from './services/location-data-parser';
import { AuthInterceptor } from './auth/services/auth-interceptor.service';
import {environment} from '../environments/environment';

/**
 * Initializes the authentication service during application bootstrap.
 * @param authService - The authentication service instance
 * @returns A function that returns a Promise resolving to the initialization result
 */
export function initializeAuth(authService: AuthService) {
  return () => authService.init().catch(error => {
    console.error('[Auth] Initialization failed:', error);
    return false;
  });
}

/**
 * Initializes the location data parser service.
 * @param parser - The location data parser service instance
 * @returns A function that returns a Promise
 */
export function initializeLocationDataParser(parser: LocationDataParser) {
  return () => Promise.resolve();
}

/**
 * Application configuration object that sets up providers and initialization.
 * Configures routing, animations, HTTP client, forms, and various services.
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    importProvidersFrom(ReactiveFormsModule, FormsModule),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeLocationDataParser,
      deps: [LocationDataParser],
      multi: true,
    },
    provideMarkdown(),
    provideUnleashProxy({
      url: 'https://us.app.unleash-hosted.com/usee0020/api/frontend/',
      clientKey: environment.unleashFrontEndKey,
      appName: 'web-app',
    })
  ]
};
